import ContentStorage from '../../tnew/content/ContentStorage';


const COMPONENT_KEY = '32a0f2f8-6d0e-4f70-bb20-c03b3e9d24ad';

const get = name => ContentStorage.get(COMPONENT_KEY, name);


class FormFieldsComponent {
  static get requiredFieldValidationMessage() {
    return get('RequiredFieldValidationMessage');
  }
}


export default FormFieldsComponent;



// WEBPACK FOOTER //
// ./src/onePageGiving/components/FormFieldsComponent.js